/**
 * Alarm notification settings resource (A6) — typed wrappers over the
 * per-org GET/PUT `/v1/iot/alarms/notify-settings` endpoints that back the
 * alarms route's "Notifications" panel.
 *
 * The server scopes everything to the active org (X-Org-Id); a GET on an
 * org that never saved settings returns the defaults (empty recipients,
 * min_severity "warning", enabled true). Saving recipients here only
 * arms email delivery — the alarm engine still no-ops the actual SES send
 * until the operator configures AWS SES (SES_SENDER_EMAIL + verified
 * sender + ses:SendEmail).
 */

import { api } from "@/lib/api-client";
import type { NotifySettings, NotifySettingsPutBody } from "./types";

export const alarmNotify = {
  /** Read the active org's notification settings (defaults if never saved). */
  get: () => api.get<NotifySettings>("/v1/iot/alarms/notify-settings"),
  /** Upsert the active org's notification settings; returns the persisted row. */
  put: (body: NotifySettingsPutBody) =>
    api.put<NotifySettings>("/v1/iot/alarms/notify-settings", body),
};
